import React from 'react'
import { connect } from 'react-redux'
import { fetchPlaylists, setOrder } from '../../redux/actions/playlists'
import { withRedux } from '../reduxContainer'
import PropTypes from 'prop-types'
import { playlists } from '../../redux/selectors/playlists'
import ItemTileGrid from '../itemTile/ItemTileGrid'
import PlaylistTile from '../playlist/PlaylistTile'
import SortableList from '../sortableList/SortableList'
import './PlaylistGrid.scss'

class PlaylistGrid extends React.Component {
  componentDidMount() {
    if (this.props.defaultOrder) {
      this.props.setOrder(this.props.defaultOrder)
    }
    this.props.fetchPlaylists(true)

    window.onpopstate = (e) => {
      const order = e.state
      this.props.setOrder(order)
      this.props.fetchPlaylists(true)
    }
  }

  render() {
    return (
      <div className='PlaylistGrid'>
        <div className='PlaylistGrid__sortingRow'>
          <div className='PlaylistGrid__totalPlaylists'>
            Showing {this.props.total || 0} Playlists
          </div>
          <div className='PlaylistGrid__sortableList'>
            <SortableList
              order={this.props.order || 'date'}
              sortableFields={['date', 'az', 'rank']}
              sortLocation={'playlists'}
              onSort={(order) => {
                this.props.setOrder(order)
                this.props.fetchPlaylists(true, () => {
                  window.history.pushState(
                    this.props.order,
                    null,
                    `${this.props.baseUrl}?order=${this.props.order}`
                  )
                })
              }}
            />
          </div>
        </div>
        <div className='PlaylistGrid__playlistGrid'>
          <ItemTileGrid
            isLoading={this.props.loading}
            hasMore={this.props.playlists.length < this.props.total}
            onLoadMore={this.props.fetchPlaylists}
            layout='tile'
            scrollThreshold={100}
            tilesPerRow={{
              768: 3,
              992: 4,
              1200: 5
            }}
            renderItemTiles={() => {
              if (!this.props.reloadingAll) {
                return this.props.playlists.map((playlist) => (
                  <div className='product' key={playlist.uuid}>
                    <PlaylistTile playlist={playlist} />
                  </div>
                ))
              }
            }}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    playlists: playlists(state),
    total: parseInt(state.ui.playlists.total),
    loading: state.ui.playlists.loading,
    order: state.ui.playlists.order,
    reloadingAll: state.ui.playlists.reloadingAll
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPlaylists: (reloadAll, callback) => {
      dispatch(fetchPlaylists(reloadAll, callback))
    },
    setOrder: (order) => {
      dispatch(setOrder(order))
    }
  }
}

PlaylistGrid.propTypes = {
  defaultOrder: PropTypes.string,
  baseUrl: PropTypes.string,
  fetchPlaylists: PropTypes.func,
  playlists: PropTypes.array,
  total: PropTypes.number,
  order: PropTypes.string,
  setOrder: PropTypes.func,
  loading: PropTypes.bool,
  reloadingAll: PropTypes.bool
}

export default withRedux(
  connect(mapStateToProps, mapDispatchToProps)(PlaylistGrid)
)
